import './footer.css';
import { Container, Grid, Header } from "semantic-ui-react";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <div className='footer-section'>
            <Container className='footer'>
                <Grid doubling stackable>
                    <Grid.Row columns={2} verticalAlign='top'>
                        <Grid.Column verticalAlign='top' textAlign='center'>
                            <Header as='h1' content='VIS GROUP' className='footer-h1' />
                            <Header as='h2' content='HVAC Specialists' className='footer-h2' />
                            <Header as='h3' content='Installation & Contracting' className='footer-h3' />
                            <div className="footer-address-block">
                                <p className="footer-details">41 Rothersthorpe Avenue</p>
                                <p className="footer-details">NN4 8JH Northampton</p>
                                <p className="footer-details">United Kingdom</p>
                            </div>
                        </Grid.Column>
                        <Grid.Column verticalAlign='middle' textAlign='center'>
                            <div className="footer-details-block">
                                <div className="footer-person">
                                    <p className="footer-details">Ion Cecoi</p>
                                    <p className="footer-details">+44 1604 217969</p>
                                    <p className="footer-details">ioncecoi@visgroup.co.uk</p>
                                </div>
                                <div className="footer-person">
                                    <p className="footer-details">Vasili Butnaru</p>
                                    <p className="footer-details">+44 7850 048527</p>
                                    <p className="footer-details">vasilibutnaru@visgroup.co.uk</p>
                                </div>
                                <div className="footer-person">
                                    <p className="footer-details">Ali Hamza</p>
                                    <p className="footer-details">+44 1604 213217</p>
                                    <p className="footer-details">alihamza@visgroup.co.uk</p>
                                </div>
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={1} textAlign='center'>
                        <Grid.Column>
                            <p className="footer-copy-rights">
                                © {currentYear} Powered by<span> </span>
                                <a href="https://maximdomentii.com" target="_blank" className="powered-by">
                                    maximdomentii.com
                                </a>
                            </p>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        </div>
    )
};

export default Footer;
